{
  "name": "aura-statelemscreator",
  "version": "2.0.1",
  "private": true,
  "dependencies": {
    "@auravisionlabs/aura-pkg-auth-service": "1.5.8",
    "@auravisionlabs/aura-pkg-ui-formatter": "1.4.1",
    "@auravisionlabs/aura-react": "^0.1.5",
    "@auth0/auth0-spa-js": "^2.14.0",
    "@blueprintjs/core": "^6.7.0",
    "@blueprintjs/datetime": "^6.0.14",
    "@blueprintjs/select": "^6.0.14",
    "@dnd-kit/core": "^6.3.1",
    "@dnd-kit/modifiers": "^9.0.0",
    "@dnd-kit/sortable": "^10.0.0",
    "@dnd-kit/utilities": "^3.2.2",
    "@sentry/react": "^10.38.0",
    "@vis.gl/react-google-maps": "^1.9.0",
    "@wojtekmaj/react-timerange-picker": "^6.0.0",
    "ajv": "^8.18.0",
    "ajv-errors": "^3.0.0",
    "ajv-formats": "^3.0.1",
    "awaity": "^1.0.0",
    "country-codes-list": "^2.0.0",
    "currency-codes": "^2.2.0",
    "dexie": "^4.0.11",
    "hls.js": "^1.6.15",
    "immutable": "^5.0.0-beta.5",
    "lodash": "^4.17.15",
    "moment": "^2.27.0",
    "moment-timezone": "^0.5.47",
    "parcel": "^2.16.4",
    "react": "^19.1.0",
    "react-custom-scrollbars-2": "^4.4.0",
    "react-data-grid": "^7.0.0-beta.57",
    "react-dom": "^19.1.0",
    "react-router": "^7.13.0",
    "styled-components": "^6.1.0",
    "uuid": "^3.4.0"
  },
  "scripts": {
    "start": "parcel src/index.html --port 3300",
    "build": "parcel build src/index.html --dist-dir build --no-cache",
    "prebuild": "rm -rf dist",
    "test": "jest",
    "test:watch": "jest --watch"
  },
  "eslintConfig": {
    "extends": "react-app"
  },
  "alias": {
    "react": "./node_modules/react",
    "@blueprintjs/core": "./node_modules/@blueprintjs/core"
  },
  "browserslist": [
    "last 5 chrome versions"
  ],
  "devDependencies": {
    "@babel/core": "^7.24.4",
    "@babel/preset-env": "^7.29.0",
    "@babel/preset-react": "^7.28.5",
    "@testing-library/dom": "^10.4.2",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.2",
    "babel-jest": "^30.2.0",
    "buffer": "^6.0.3",
    "crypto-browserify": "^3.12.0",
    "events": "^3.3.0",
    "https-browserify": "^1.0.0",
    "jest": "^30.2.0",
    "jest-environment-jsdom": "^30.2.0",
    "process": "^0.11.10",
    "stream-browserify": "^3.0.0",
    "stream-http": "^3.2.0",
    "string_decoder": "^1.3.0",
    "url": "^0.11.4",
    "util": "^0.12.5",
    "vm-browserify": "^1.1.2"
  }
}
